// @flow
import React, { useEffect, useState } from 'react';

import DropdownInput from 'components/fragments/input/DropdownInput';
import type { PlayersStatsType } from 'types/competitionsInternationales';

type Props = {
  players_stats: PlayersStatsType[]
};

export const DROPS = 'drops';
export const ESSAIS = 'essais';
export const PENALITES = 'penalites';
export const TRANSFORMATION = 'transformation';
export const NOM = 'nom';
const PLAYERS_TAB_OPTIONS = [
  { label: 'Noms', value: NOM },
  { label: 'Drops', value: DROPS },
  { label: 'Essais', value: ESSAIS },
  { label: 'Penalités', value: PENALITES },
  { label: 'Transformation', value: TRANSFORMATION }
];

export const DEFAULT_OPTIONS = [];

function CompetitionsInternationalesHomeOverPlayersTab({ players_stats }: Props) {
  const [sortOption, setSortOption] = useState((new Set(DEFAULT_OPTIONS): any));
  const [numberToDisplay, setNumberToDisplay] = useState(5);
  const [playersToDisplay, setPlayersToDisplay] = useState([]);

  useEffect(() => {
    let newPlayersToDisplay = [];

    newPlayersToDisplay = players_stats.map(player => {
      let total_essais = 0;
      let total_transfos = 0;
      let total_drops = 0;
      let total_penalites = 0;

      if (!!player.current_competition_matchs_stats.length) {
        player.current_competition_matchs_stats.map(match_stat => {
          total_essais += match_stat.essais;
          total_transfos += match_stat.transformation;
          total_drops += match_stat.drops;
          total_penalites += match_stat.penalites;
        });
      }

      return {
        id: player.id,
        nom: player.nom,
        drops: total_drops,
        essais: total_essais,
        penalites: total_penalites,
        transformation: total_transfos
      };
    });

    if (!sortOption.length || sortOption.includes(NOM)) {
      newPlayersToDisplay = newPlayersToDisplay.sort((a, b) => (a.nom > b.nom ? 1 : a.nom < b.nom ? -1 : 0));
    } else {
      newPlayersToDisplay = newPlayersToDisplay.sort((a, b) =>
        a[sortOption[0]] < b[sortOption[0]] ? 1 : a[sortOption[0]] > b[sortOption[0]] ? -1 : 0
      );
    }

    newPlayersToDisplay = newPlayersToDisplay.slice(0, numberToDisplay);

    setPlayersToDisplay(newPlayersToDisplay);
  }, [numberToDisplay, players_stats, sortOption]);

  if (!players_stats.length) {
    return null;
  }

  const onFilterChange = (value: string) => {
    let newFilter = [value];

    setSortOption(newFilter);
  };

  return (
    <div className="wp-block-ffr-rencontres-itl-competition-classement classement classement--joueurs">
      <div className="dropdown-container">
        <DropdownInput
          id="players-tab"
          counter={0}
          label="Trier"
          options={PLAYERS_TAB_OPTIONS}
          selected={Array.from(sortOption)}
          inputChanged={onFilterChange}
          className={'dropdown dropdown--noBorder dropdown--checkbox'}
        />
      </div>
      <div className={'ranking box box--smoke'}>
        <div className="ranking__top-content">
          <div className="ranking__title">
            <span>Statistiques individuelles</span>
            {/* <img src={rankingLogoSource} alt="logo" /> */}
          </div>

          <table className="no-table">
            <thead>
              <tr>
                <th className="ranking__name">Composition</th>
                <th className="ranking__stat">
                  <abbr title="Joué">Essais</abbr>
                </th>{' '}
                <th className="ranking__stat">
                  <abbr title="Joué">Transfos</abbr>
                </th>{' '}
                <th className="ranking__stat">
                  <abbr title="Joué">Drops</abbr>
                </th>{' '}
                <th className="ranking__stat">
                  <abbr title="Joué">Pénalités</abbr>
                </th>
              </tr>
            </thead>

            <tbody>
              {playersToDisplay.map(player => {
                return (
                  <tr key={player.id}>
                    <td className="ranking__name">{player.nom}</td>
                    <td className="ranking__stat">{player.essais}</td>
                    <td className="ranking__stat">{player.transformation}</td>
                    <td className="ranking__stat">{player.drops}</td>
                    <td className="ranking__stat">{player.penalites}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {numberToDisplay < players_stats.length && (
        <div className="classement--joueurs__button-container">
          <button
            className="btn--competitions-internationales link-container-btn"
            onClick={() => setNumberToDisplay(players_stats.length)}
          >
            Voir plus
          </button>
        </div>
      )}
    </div>
  );
}

export default CompetitionsInternationalesHomeOverPlayersTab;
